import { render } from "./App.vue?vue&type=template&id=5c0cb578&scoped=true"
import script from "./app.js?vue&type=script&lang=js&external"
export * from "./app.js?vue&type=script&lang=js&external"

import "./app.scss?vue&type=style&index=0&id=5c0cb578&lang=scss&scoped=true&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0cb578"]])

export default __exports__